import ArticleLayout from '@/components/feature/ArticleLayout';
import { kakobuyArticle } from '@/mocks/article-data';
import ArticleSchema from '@/components/feature/ArticleSchema';

export default function KakobuyArticle() {
  return (
    <>
      <ArticleSchema
        slug="kakobuy-spreadsheet-guide"
        title="Kakobuy Spreadsheet Complete Guide 2026"
        description="Comprehensive Kakobuy Spreadsheet guide covering navigation, category comparisons, safety practices, and expert shopping strategies. Learn how Kakobuy Spreadsheet compares with Hipobuy, CSSBuy, Superbuy and Oopbuy platforms."
        imageUrl="https://readdy.ai/api/search-image?query=Urban%20streetwear%20fashion%20scene%20with%20denim%20jackets%20sneakers%20and%20graphic%20tees%20styled%20on%20industrial%20concrete%20backdrop%2C%20edgy%20editorial%20photography%2C%20moody%20atmospheric%20lighting%20with%20neon%20pink%20accents%2C%20contemporary%20youth%20culture%20aesthetic%2C%20gritty%20urban%20texture%20contrast%20with%20polished%20product%20styling&width=1920&height=800&seq=article-kakobuy-hero-v2&orientation=landscape"
      />
      <ArticleLayout article={kakobuyArticle} />
    </>
  );
}